<template>
    <window title="Beschläge melden" size="md">
        <template slot-scope="window">
            <job-fitting :fitting="fitting" class="mb-mdsm"></job-fitting>

            <editable name="message" :show-toggle-button="false" default-state="edit" :initial-data="message">
                <template slot-scope="editable">
                    <editable-text name="text" label="Mitteilung an den Projektleiter" placeholder="Beschreiben Sie das Problem"></editable-text>

                    <div class="buttons">
                        <button class="btn btn-secondary" @click="window.hide()">
                            Abbrechen
                        </button>

                        <button class="btn btn-primary" @click="window.hide(editable.data)">
                            Absenden
                        </button>
                    </div>
                </template>
            </editable>
        </template>
    </window>
</template>

<script>
import JobFitting from './JobFitting';

export default {
    components: {
        'job-fitting': JobFitting
    },
    provide: {
        windowId: 'jobFittingsMessage'
    },
    props: {
        fitting: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            default() {
                return {};
            }
        }
    }
}
</script>